import { render } from "./DataJamKhusus.vue?vue&type=template&id=21b5bab7"
import script from "./DataJamKhusus.vue?vue&type=script&lang=js"
export * from "./DataJamKhusus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__